<template>
    <div class="clearfix">
        <compFormEdit ref="form"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1"
        ></compFormEdit>
        <div class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</Button>
            <Button type="default" @click="$emit('on-close')">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetShippingDetail,
    HttpUpdateShippingAccount,
    HttpOrgServiceWarehouseList
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    props: ['activeid', 'querytype'],
    data () {
        return {
            formData: {},
            warehouseList: [],
            loading: false
        }
    },
    created () {
        HttpOrgServiceWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.carrierServiceName})`
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
        if (this.querytype !== 'add') {
            this.getDetail();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
        ]),
        getBase () {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'warehouseId',
                    tag: 'vSelect',
                    options: this.warehouseList,
                    props: {
                        filterable: true
                    },
                    query: this.querytype === 'edit',
                    required: true
                },
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    key: 'carrierId',
                    tag: 'vSelect',
                    options: this.getCarrierAllList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.id
                        }
                    }),
                    props: {
                        filterable: true
                    },
                    query: this.querytype === 'edit',
                },
                {
                    label: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: 'Shipping账号' }),
                    key: 'carrierAccount',
                    tag: 'vInput'
                }
            ]
        },
    },
    methods: {
        async getDetail () {
            this.loading = true;
            await HttpGetShippingDetail({
                id: this.activeid
            }).then(res => {
                this.formData = res.data;
                console.log(res.data.carrierId)
                console.log(this.getCarrierAllList);
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        async submit () {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            this.loading = true;
            await HttpUpdateShippingAccount({
                id: this.activeid,
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-update');
                this.$emit('on-close');
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        }
    }
}
</script>

<style>

</style>